import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { colors } from '../tokens'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    padding: '10px 20px',
    fontSize: '13px',
    color: colors.muted,
  },
  perPage: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
  },
  selectWrap: {
    position: 'relative',
    display: 'inline-flex',
  },
  select: {
    appearance: 'none',
    WebkitAppearance: 'none',
    padding: '4px 20px 4px 4px',
    border: 0,
    outline: 'none',
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    color: colors.navy,
  },
  chevron: {
    position: 'absolute',
    top: '50%',
    right: 2,
    transform: 'translateY(-50%)',
    display: 'inline-flex',
    pointerEvents: 'none',
  },
  buttons: {
    display: 'inline-flex',
    gap: '2px',
  },
  button: {
    display: 'inline-flex',
    padding: 4,
    border: 0,
    borderRadius: '6px',
    background: 'transparent',
    fontFamily: 'inherit',
    '&:hover:not(:disabled)': {
      background: colors.hover,
    },
  },
})

/**
 * "Rows per page · 1–10 of 42 · |< < > >|" footer for tables and lists.
 * `page` is 0-based.
 */
const Pagination = ({
  total,
  page,
  pageSize,
  pageSizes = [10, 25, 50],
  onPageChange,
  onPageSizeChange,
  className,
}) => {
  const classes = useStyles()
  const lastPage = Math.max(0, Math.ceil(total / pageSize) - 1)
  const from = total === 0 ? 0 : page * pageSize + 1
  const to = Math.min((page + 1) * pageSize, total)

  const button = (icon, title, target, disabled) => (
    <button
      type="button"
      title={title}
      className={classes.button}
      style={{
        color: disabled ? colors.disabled : colors.navy,
        cursor: disabled ? 'default' : 'pointer',
      }}
      disabled={disabled}
      onClick={() => onPageChange(target)}
    >
      <Icon icon={icon} width={18} height={18} />
    </button>
  )

  return (
    <div className={`${classes.root} ${className || ''}`}>
      <span className={classes.perPage}>
        Rows per page:
        <span className={classes.selectWrap}>
          <select
            className={classes.select}
            value={pageSize}
            onChange={event => onPageSizeChange(Number(event.target.value))}
          >
            {pageSizes.map(size => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          <span className={classes.chevron}>
            <Icon icon="tabler:chevron-down" width={14} height={14} />
          </span>
        </span>
      </span>
      <span>
        {from}–{to} of {total}
      </span>
      <span className={classes.buttons}>
        {button('tabler:chevrons-left', 'First page', 0, page === 0)}
        {button('tabler:chevron-left', 'Previous page', page - 1, page === 0)}
        {button(
          'tabler:chevron-right',
          'Next page',
          page + 1,
          page >= lastPage,
        )}
        {button(
          'tabler:chevrons-right',
          'Last page',
          lastPage,
          page >= lastPage,
        )}
      </span>
    </div>
  )
}

export default Pagination
